/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react'
import { useKeycloak } from '@react-keycloak/web'
import { LanguageConsumer } from '../../LanguageContext'
import Anonymous from './Anonymous'
import { AuthenticatedUserConsumer } from '../../AuthenticatedUserContext'
import AdminSections from './AdminSections'
import NotAdminUser from './NotAdminUser'

const AdminIntro = () => {
  const { keycloak } = useKeycloak()
  return (
    <LanguageConsumer>
      {({ locale }) => (
        <AuthenticatedUserConsumer>
          {({ isAdmin, handleAdminSectionChange }) => (
            !!keycloak?.authenticated ?
              (!!isAdmin ? <AdminSections handleAdminSectionChange={handleAdminSectionChange}/>: <NotAdminUser/>) :
              <Anonymous locale={locale}/>
          )}
        </AuthenticatedUserConsumer>

      )}
    </LanguageConsumer>
  )
}

export default AdminIntro
